import { useCallback, useRef } from "react";

export default function useScrollResetOnMount() {
  const isInitialLoadRef = useRef(true);

  const resetScrollToTop = useCallback(() => {
    if (!isInitialLoadRef.current) return;
    isInitialLoadRef.current = false;
    window.scrollTo(0, 0);
    window.history.scrollRestoration = "auto";
  }, []);

  return resetScrollToTop;
}
